import { ControlledAirspaceAdvisory } from './advisories/ControlledAirspaceAdvisory.tsx';
import { DCFRZAdvisory } from './advisories/DCFRZAdvisory.tsx';
import { LAANCAdvisory } from './advisories/LAANCAdvisory.tsx';
import { NSUFRAdvisory } from './advisories/NSUFRAdvisory.tsx';
import { PartTimeNSUFRAdvisory } from './advisories/PartTimeNSUFRAdvisory.tsx';
import { SpecialUseAdvisory } from './advisories/SpecialUseAdvisory.tsx';
import { DayNightAdvisory } from './advisories/time-of-day/DayNightAdvisory.tsx';
import { StateAndLocalAdvisory } from './advisories/StateAndLocalAdvisory.tsx';
import { NOTAMAdvisory } from './advisories/NOTAMAdvisory.tsx';
import { TFRListAdvisory } from './advisories/TFRAdvisory.tsx';
import { NoTFRAdvisory } from './advisories/NoTFRAdvisory.tsx';
import { StadiumsAdvisory } from './advisories/StadiumsAdvisory.tsx';
import { SEAMSAdvisory } from './advisories/SEAMSAdvisory.tsx';
import { MissionFeatureCollection } from '@autopylot-internal/tiles-client';
import { UncontrolledAirspaceAdvisory } from './advisories/UncontrlledAirspaceAdvisory.tsx';
import { ConcurrentMissionsAdvisory } from './advisories/ConcurrentMissionsAdvisory.tsx';
import { NationalParkAdvisory } from './advisories/NationalParkAdvisory.tsx';
import { WildernessAreaUSFSAdvisory } from './advisories/WildernessAreaUSFSAdvisory.tsx';
import { WildernessAreaFWSAdvisory } from './advisories/WildernessAreaFWSAdvisory.tsx';
import { WildernessAreaBLMAdvisory } from './advisories/WildernessAreaBLMAdvisory.tsx';
import { WildlifeRefugeAdvisory } from './advisories/WildlifeRefugeAdvisory.tsx';
import { CDFWPublicLandsAdvisory } from './advisories/CDFWPublicLandsAdvisory.tsx';
import { FRIAAdvisory } from './advisories/FRIAAdvisory.tsx';
import { ScheduledAirspaceAdvisory } from './advisories/ScheduledAirspaceAdvisory.tsx';
import { CompositeTFRAdvisory } from './advisories/CompositeTFRAdvisory.tsx';
import { AirspaceBoundaryAdvisory } from './advisories/AirspaceBoundaryAdvisory.tsx';
import { MilitaryTrainingRoutesAdvisory } from './advisories/MilitaryTrainingRoutesAdvisory.tsx';
import { RecreationalFlyerFixedSitesAdvisory } from './advisories/RecreationalFlyerFixedSitesAdvisory.tsx';
import { OperationalAwarenessAdvisory } from './advisories/OperationalAwarenessAdvisory.tsx';

const NoOp = () => null;

const advisoryToComponentMap = {
    // NoOp below in cases where we render a composite instead
    'nsufr': NSUFRAdvisory,
    'parttime-nsufr': PartTimeNSUFRAdvisory,
    'special-use-airspace': SpecialUseAdvisory,
    'airspace': ControlledAirspaceAdvisory,
    'airspace+class-g': UncontrolledAirspaceAdvisory,
    'dc-frz': DCFRZAdvisory,
    'stadiums': NoOp,
    'stadiums+composite': StadiumsAdvisory,
    'seams': NoOp,
    'seams+composite': SEAMSAdvisory,
    'uasfm+airspace': NoOp,
    'uasfm+airspace+composite': LAANCAdvisory,
    'uasfm+authorizable': NoOp,
    'time-of-day': DayNightAdvisory,
    'concurrent-missions': ConcurrentMissionsAdvisory,
    'no-tfr': NoTFRAdvisory,
    'state-and-local': StateAndLocalAdvisory,
    'notam': NOTAMAdvisory,
    'national-parks': NoOp,
    'national-parks+composite': NationalParkAdvisory,
    'wilderness-areas-usfs': NoOp,
    'wilderness-areas-usfs+composite': WildernessAreaUSFSAdvisory,
    'wilderness-areas-fws': NoOp,
    'wilderness-areas-fws+composite': WildernessAreaFWSAdvisory,
    'wilderness-areas-blm': NoOp,
    'wilderness-areas-blm+composite': WildernessAreaBLMAdvisory,
    'wildlife-refuges': NoOp,
    'wildlife-refuges+composite': WildlifeRefugeAdvisory,
    'cdfw-public-lands': NoOp,
    'cdfw-public-lands+composite': CDFWPublicLandsAdvisory,
    'fria': NoOp,
    'fria+composite': FRIAAdvisory,
    'tfr': TFRListAdvisory,
    'scheduled-airspace': ScheduledAirspaceAdvisory,
    'temporary-flight-restrictions': NoOp,
    'temporary-flight-restrictions+composite': CompositeTFRAdvisory,
    'airspace-boundary': AirspaceBoundaryAdvisory,
    'military-training-routes': NoOp,
    'military-training-routes+composite': MilitaryTrainingRoutesAdvisory,
    'rec-flyer-fixed-sites': RecreationalFlyerFixedSitesAdvisory,
    'operational-awareness': OperationalAwarenessAdvisory,
};

/**
 * Why is this called FAAAdvisory? Mostly b/c naming is hard, it because at this time,  99% of what it abstracts
 * is how to render an advisory given feature data from the FAA
 */
export const FAAAdvisory = ({ source, advisory, mission }: { source: string, advisory: any, mission: MissionFeatureCollection }) => {
    const Advisory = (advisoryToComponentMap as any)[source];
    if (Advisory) {
        return (
            <div data-advisory-source={source}>
                <Advisory {...advisory} mission={mission} />
            </div>
        );
    }
    else {
        console.log(JSON.stringify(advisory));
        return null;
    }
};
